module.exports = __webpack_public_path__ + "static/media/arrow-dark.4c3eb481.svg";